import * as React from 'react';
import * as formUtils from '../../utils/form-utils';
import FormItem from 'antd/lib/form/FormItem';

export interface StaticFormItemProps {
  style?: React.CSSProperties;
  label: React.ReactNode;
  initialValue: React.ReactNode;
  className?: string;
}

class StaticFormItem extends React.Component<StaticFormItemProps, {}> {

  public render(): React.ReactNode {
    const {label, initialValue, className, style} = this.props;
    return (
      <FormItem
        className={className}
        {...formUtils.formItemLayout}
        style={style}
        label={label}
      >
        <span className="ant-form-text">{initialValue}</span>
      </FormItem>
    );
  }
}

export default StaticFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/StaticFormItem.tsx